<template>
    <div class="back">
        <div class="backpage" @click="backPrevPage" v-if="backBtn">返回</div>
        <el-backtop target="#xtwrap" :bottom="60">
            <div class="backtop">Top</div>
        </el-backtop>
    </div>
</template>
<style scoped>
    .back {
        height: auto;
        background: #fff;
        position: fixed;
        right: 40px;
        bottom: 60px;
        z-index: 999;
        border-radius: 2px;
        overflow: hidden;
        transition: 0.6s;
        box-shadow: 0 0 6px rgba(0,0,0,.12);
        @media only screen and (min-width: 300px) and (max-width: 768px) {
            right: 10px;
            bottom: 20px;
        }
    }
    .backpage,
    .backtop {
        height: 40px;
        width: 40px;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1a46a7;
        cursor: pointer;
    }
    .el-backtop {
        position: static;
        border-radius: 0;
    }
    .backtop {
        border-top: 1px solid #f0f1f2;
    }
</style>
<script>
export default {
    data() {
        return {
            backBtn: false
        }
    },
    watch: {
        $route(to,from){
            if (window.history.length > 2) this.backBtn = true
        }
    },
    methods: {
        backPrevPage() {
            if (window.history.length <= 2) {
                this.$router.push({path:'/'})
                return false
            } else {
                this.$router.go(-1)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/view/layout/Back.vue